// src/constants/eventConstants.js

export const EVENT_CATEGORIES = [
    'BUDGETING',
    'SAVING',
    'NETWORKING',
    'FUNDRAISER',
    'INVESTING',
    'DEBT_MANAGEMENT',
    'CREDIT_SCORE',
    'FINANCIAL_PLANNING',
    'RETIREMENT_PLANNING',
    'FINANCIAL_EDUCATION',
    'HOME_PURCHASE',
    'CAREER_DEVELOPMENT',
    'OTHER'
  ];
  
  export const LOCATION_TYPES = {
    PHYSICAL: 'physical',
    REMOTE: 'remote'
  };
  
  // Optional: Category display names for better UI
  export const CATEGORY_DISPLAY_NAMES = {
    BUDGETING: 'Budgeting',
    SAVING: 'Saving',
    NETWORKING: 'Networking',
    FUNDRAISER: 'Fundraiser',
    INVESTING: 'Investing',
    DEBT_MANAGEMENT: 'Debt Management',
    CREDIT_SCORE: 'Credit Score',
    FINANCIAL_PLANNING: 'Financial Planning',
    RETIREMENT_PLANNING: 'Retirement Planning',
    FINANCIAL_EDUCATION: 'Financial Education',
    HOME_PURCHASE: 'Home Purchase',
    CAREER_DEVELOPMENT: 'Career Development',
    OTHER: 'Other'
  };